module.exports = __webpack_public_path__ + "img/Twitter.0db52991.png";